export default {
  staffs: []
}
